import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  required,
  rows = 4,
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-58">
      <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-59">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-60">*</span>}
      </label>
      <textarea className={`w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow resize-none ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300'} ${className}`} rows={rows} required={required} {...props} data-id="element-61" />
      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-62">
          {error}
        </p>}
    </div>;
}